<!-- 单片数量 -->
<template>
  <div>
    <BaseFormItem2
      class="quote-bcount"  
      :unit="unit"
      :label="label"
      :labelTips="fields.labelTips"
      :fillTips="fillTips"
      :isError="isError || !!areaTips"
      :isErrorBlink="isErrorBlink"
      :isShake="isShake"
    >
      <BaseSelect2
        ref="bcountSelect"
        v-model="val" 
        popper-class="quote-bcount__select" 
        width="152px"
        placeholder="请选择"
        :isError="isError"
        @change="handleEmit"
      >
        <el-option
          v-for="item in fields.options"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
        <div class="bcount__select__other">
          <p>
            其它数量：
            <span v-show="areaLimit > 0">(数量x长x宽需大于{{areaLimit}}㎡)</span>
          </p>
          <div>
            <BaseInput2
              v-model="otherVal" 
              size="mini" 
              width="150px"
              @keyup.enter.native="handleUseOther"
            ></BaseInput2>
            <BaseButton size="mini" class="bcount__select__other__btn" @click="handleUseOther">确定</BaseButton>
          </div>
        </div>
      </BaseSelect2>

      <div slot="other">
        <template v-if="units == 2 && pcsNum">
          <span>=</span>
          <span class="bcount__pcsnum">{{ pcsNum }}</span>
          <span>Pcs</span>
        </template>

        <span v-if="area" class="bcount__area">
          （订单面积 {{(area / 10000).toFixed(4)}}㎡）
        </span>
      </div>

      <!-- 面积提示 -->
      <div v-if="areaTips" slot="extend" class="bcount__areaTips">
        {{ areaTips }}
      </div>

      <!-- 阶梯价格表 -->
      <div v-if="isFR4" slot="extend" class="bcount__extend">
        <LadderPrice 
          :ladderPriceData="ladderPriceData" 
          @tipsChange="handleTipsChange"
        />
      </div>
    </BaseFormItem2>
  </div>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'
import LadderPrice from '@@/views/pcbQuote/components/ladderPrice'

export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    // 板子层数
    blayer: {
      type: Number,
      default: 2
    },
    // 出货形式
    units: {
      type: Number,
      default: 1
    },
    setwidth: {
      type: [Number, String],
      default: ''
    },
    setlength: {
      type: [Number, String],
      default: ''
    },
    // 单片数量
    pcsNum: {
      type: Number,
      default: 0
    },
    // 板子面积
    area: {
      type: [Number, String],
      default: ''
    },
    // 获取阶梯价参数
    ladderPriceData: {
      type: Object,
      default: () => ({})
    },
    // 产品类别
    board_type: {
      type: String,
      default: 'FR-4'
    },
    // 板子面积提示
    areaTips: {
      type: String,
      default: ''
    }
  },
  components: {
    LadderPrice
  },
  data() {
    return {
      val: this.value,
      otherVal: '',
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('bcount')
    },
    unit() {
      return this.units == 1 ? 'Pcs' : 'Set'
    },
    label() {
      return this.units == 1 ? '单片数量' : '连片数量'
    },
    fillTips() {
      return !this.val
    },
    areaLimit() {
      return { 1: 5, 2: 5, 4: 5, 6: 3 }[this.blayer] || 0
    },
    isFR4() {
      return this.board_type == 'FR-4'
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    board_type(newVal) {
      if (newVal === 'ROGERS') {
        this.handleTipsChange('')
      }
    }
  },
  methods: {
    handleEmit() {
      this.$emit('input', this.val)
      this.$emit('change', this.val)
      this.isShowError(false)
    },
    handleUseOther() {
      const { otherVal, areaLimit, setwidth, setlength } = this
      if (otherVal > 0) {
        const minBcount = parseInt(areaLimit * 10000 / (setwidth * setlength))
        if (otherVal < minBcount) {
          this.$message.warning(`最少${minBcount}片才大于${areaLimit}平米，且数量需为5的倍数`)
        } else if (otherVal % 5 != 0) {
          this.$message.warning('输入数量需为5的倍数')
        } else {
          this.val = +otherVal
          this.otherVal = ''
          this.handleEmit()
          this.$refs.bcountSelect.getRefs().blur()
        }
      } else {
        this.$message.warning('请输入其它数量')
      }
    },
    handleTipsChange(tips) {
      this.$emit('tipsChange', tips)
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss">
.quote-bcount {
  .bcount__pcsnum {
    margin: 0 4px;
    color: $--color-primary;
  }
  .bcount__area {
    color: $--color-text-placeholder;
  }
  &.base-form-item .base-form-item__content.fill-tips,
  &.base-form-item .base-form-item__content.is-error {
    padding-right: 15px;
  }
  .bcount__extend {
    width: 100%;
  }
  .bcount__areaTips {
    width: 100%;
    color: $--color-danger;
  }
}
.quote-bcount__select {
  $backgroundColor: #F9F9F9;

  .el-select-dropdown__wrap {
    min-height: 320px;
  }
  .el-select-dropdown__list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 6px;
    width: 300px;
    .el-select-dropdown__item {
      margin-bottom: 4px;
      padding: 0;
      width: 55px;
      height: 24px;
      line-height: 22px;
      font-size: 14px;
      color: #555555;
      text-align: center;
      border: 1px solid $backgroundColor;
      background-color: $backgroundColor;
      border-radius: $--border-radius-base2;
      &.selected,
      &:hover {
        font-weight: 400;
        color: $--form-color-base;
        border-color: $--form-color-base;
      }
    }
  }
  .bcount__select__other {
    width: 100%;
    padding: 8px 12px;
    background-color: $backgroundColor;
    border-radius: $--border-radius-base2;
    >p {
      margin-bottom: 6px;
      color: $--color-text-secondary;
      >span {
        color: $--color-text-placeholder;
      }
    }
    .bcount__select__other__btn {
      margin-left: 4px;
      border-radius: $--border-radius-base2;
      color: $--form-color-base;
      border-color: #8AD3BA;
      background-color: #E8F6F1;
      &:hover {
        background-color: $--form-color-base;
      }
    }
  }
}
</style>